import type {
  EventType,
  InteractionType,
  ActionListType,
  PageAndNodeId,
  AffectedElementType,
} from '@packages/systems/ix2/types-core';
import type {RawStyleBlockServerType} from '@packages/systems/core/utils/StyleTypes';
import {Plugins} from '@packages/systems/wfdl';
import {getLibraryExportsFromPlugin} from './libraryManifest';
import type {LibraryVersionedResource, ComponentExport} from './types';
import {
  LIBRARY_EXPORT_SUBTYPES,
  LIBRARY_PROFILE_STATUS,
  LIBRARY_SOURCE,
} from './constants';
export const TEST_ASSET = {
  cdnUrl:
    'https://dev-assets.website-files.com/6306a56ed8e9b57ef801b758/6306a70dd8e9b57ef801b76b_carbon%20(7).png',
  siteId: '6306a56ed8e9b57ef801b758',
  width: 1356,
  height: 1462,
  fileName: 'carbon (7).png',
  createdOn: '2022-08-24T22:32:45.007Z',
  origFileName: 'carbon (7).png',
  fileHash: '9bb4a074f0f0916cf3eed9048d997867',
  mimeType: 'image/png',
  s3Url:
    'https://s3.amazonaws.com/webflow-dev-assets/6306a56ed8e9b57ef801b758/6306a70dd8e9b57ef801b76b_carbon%20(7).png',
  thumbUrl:
    'data:image/png;base64,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',
  _id: '6306a70dd8e9b57ef801b76b',
  markedAsDeleted: false,
  fileSize: 142526,
} as const;

export const TEST_CPG_ACTION_LIST_ITEM = {
  id: 'a',
  title: 'New Mouse Animation',
  continuousParameterGroups: [
    {
      id: 'a-p',
      type: 'MOUSE_X',
      parameterLabel: 'Mouse X',
      continuousActionGroups: [
        {
          keyframe: 0,
          actionItems: [
            {
              id: 'a-n',
              actionTypeId: 'TRANSFORM_ROTATE',
              config: {
                delay: 0,
                easing: '',
                duration: 500,
                target: {
                  nodeId:
                    '62d9d85eabf70f5be939b4af|0738276b-09d2-7383-5539-8191edcdcaa0',
                  appliesTo: 'ELEMENT',
                  boundaryMode: false,
                },
                xUnit: 'DEG',
                yUnit: 'DEG',
                zUnit: 'DEG',
              },
              instant: false,
            },
          ],
        },
        {
          keyframe: 100,
          actionItems: [
            {
              id: 'a-n-2',
              actionTypeId: 'TRANSFORM_ROTATE',
              config: {
                delay: 0,
                easing: '',
                duration: 500,
                target: {
                  nodeId:
                    '62d9d85eabf70f5be939b4af|0738276b-09d2-7383-5539-8191edcdcaa0',
                  appliesTo: 'ELEMENT',
                  boundaryMode: false,
                },
                xUnit: 'DEG',
                yUnit: 'DEG',
                zUnit: 'DEG',
              },
              instant: false,
            },
          ],
        },
      ],
    },
    {
      id: 'a-p-2',
      type: 'MOUSE_Y',
      parameterLabel: 'Mouse Y',
      continuousActionGroups: [
        {
          keyframe: 0,
          actionItems: [
            {
              id: 'a-n-3',
              actionTypeId: 'TRANSFORM_SCALE',
              config: {
                delay: 0,
                easing: '',
                duration: 500,
                target: {
                  nodeId:
                    '62d9d85eabf70f5be939b4af|0738276b-09d2-7383-5539-8191edcdcaa0',
                  appliesTo: 'ELEMENT',
                  boundaryMode: false,
                },
                locked: true,
              },
              instant: false,
            },
          ],
        },
        {
          keyframe: 100,
          actionItems: [
            {
              id: 'a-n-4',
              actionTypeId: 'TRANSFORM_SCALE',
              config: {
                delay: 0,
                easing: '',
                duration: 500,
                target: {
                  nodeId:
                    '62d9d85eabf70f5be939b4af|0738276b-09d2-7383-5539-8191edcdcaa0',
                  appliesTo: 'ELEMENT',
                  boundaryMode: false,
                },
                locked: true,
              },
              instant: false,
            },
          ],
        },
      ],
    },
  ],
  createdOn: 1663887864761,
} as const;

export const TEST_AIG_ACTION_LIST_ITEM = {
  id: 'a-3',
  title: 'New Timed Animation',
  actionItemGroups: [
    {
      actionItems: [
        {
          id: 'a-3-n',
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: '',
            duration: 500,
            target: {
              nodeId:
                '62d9d85eabf70f5be939b4a7|0738276b-09d2-7383-5539-8191edcdcaa0',
              appliesTo: 'TRIGGER_ELEMENT',
              styleBlockIds: ['5e819dec-3019-cef0-c313-0a17cd6da550'],
              boundaryMode: false,
            },
            locked: true,
          },
          instant: false,
        },
      ],
    },
    {
      actionItems: [
        {
          id: 'a-3-n-2',
          actionTypeId: 'STYLE_BACKGROUND_COLOR',
          config: {
            delay: 0,
            easing: '',
            duration: 500,
            target: {
              nodeId:
                '62d9d85eabf70f5be939b4a7|0738276b-09d2-7383-5539-8191edcdcaa0',
              appliesTo: 'TRIGGER_ELEMENT',
              styleBlockIds: ['5e819dec-3019-cef0-c313-0a17cd6da550'],
              boundaryMode: false,
            },
          },
          instant: false,
        },
      ],
    },
  ],
  createdOn: 1664231545686,
  useFirstGroupAsInitialState: false,
} as const;

export const generateTestAsset = (_id: string, versionedResource?: string) => ({
  _id,
  cdnUrl:
    'https://dev-assets.website-files.com/6306a56ed8e9b57ef801b758/6306a70dd8e9b57ef801b76b_carbon%20(7).png',
  siteId: '6306a56ed8e9b57ef801b758',
  width: 1356,
  height: 1462,
  fileName: 'test.png',
  createdOn: '2022-08-24T22:32:45.007Z',
  origFileName: 'test.png',
  fileHash: '9bb4a074f0f0916cf3eed9048d997867',
  mimeType: 'image/png',
  s3Url:
    'https://s3.amazonaws.com/webflow-dev-assets/6306a56ed8e9b57ef801b758/6306a70dd8e9b57ef801b76b_carbon%20(7).png',
  thumbUrl: 'thumbUrl',
  markedAsDeleted: false,
  fileSize: 142526,
  ...(versionedResource ? {versionedResource} : {}),
});

export const PLACEHOLDER_ASSET = {
  _id: 'examplebg',
  cdnUrl: 'https://d3e54v103j8qbb.cloudfront.net/img/image-placeholder.svg',
  siteId: '6306a56ed8e9b57ef801b758',
  width: 1356,
  height: 1462,
  fileName: 'image-placeholder.svg',
  createdOn: '2022-08-24T22:32:45.007Z',
  origFileName: 'image-placeholder.svg',
  fileHash: '9bb4a074f0f0916cf3eed9048d997868',
  mimeType: 'image/svg',
  s3Url:
    'https://s3.amazonaws.com/webflow-prod-assets/6306a56ed8e9b57ef801b758/6306a70dd8e9b57ef801b76b_image-placeholder.svg',
  thumbUrl: 'thumbUrl',
  markedAsDeleted: false,
  fileSize: 142526,
  placeholder: true,
};

export const generateTestIx2Interaction = (
  targetId: string,
  interactionId?: string
): InteractionType => ({
  id: interactionId || 'i-2',
  interactionTypeId: 'MOUSE_HOVER_INTERACTION',
  eventIds: ['e-3', 'e-4'],
  target: `62d9d85eabf70f5be939b4af|${targetId}`,
  createdOn: 1663883254354,
});

export const generateTestIx2Event = (
  targetId: string,
  eventId?: string
): EventType => ({
  id: eventId || 'e-3',
  name: '',
  animationType: 'preset',
  eventTypeId: 'MOUSE_OVER',
  action: {
    id: '',
    actionTypeId: 'SLIDE_EFFECT',
    config: {
      actionListId: 'SLIDE_EFFECT',
      autoStopEventId: 'e-4',
      affectedElements: new Map<PageAndNodeId, AffectedElementType>(),
      delay: 0,
      easing: '',
      duration: 0,
      playInReverse: false,
    },
    instant: false,
  },
  mediaQueries: ['main', 'medium', 'small', 'tiny'],
  target: {
    appliesTo: 'ELEMENT',
    styleBlockIds: [],
    id: `62d9d85eabf70f5be939b4af|${targetId}`,
  },
  targets: [],
  config: {
    loop: false,
    playInReverse: false,
    scrollOffsetValue: null,
    scrollOffsetUnit: null,
    delay: 0,
    direction: 'LEFT',
    effectIn: true,
  },
  createdOn: 1663883254354,
});

export const generateTestIx2TargetsEvent = (
  targetId: string,
  eventId?: string
): EventType => ({
  id: eventId || 'e-3',
  name: '',
  animationType: 'preset',
  eventTypeId: 'MOUSE_OVER',
  action: {
    id: '',
    actionTypeId: 'SLIDE_EFFECT',
    config: {
      actionListId: 'SLIDE_EFFECT',
      autoStopEventId: 'e-4',
      affectedElements: new Map<PageAndNodeId, AffectedElementType>(),
      delay: 0,
      easing: '',
      duration: 0,
      playInReverse: false,
    },
    instant: false,
  },
  mediaQueries: ['main', 'medium', 'small', 'tiny'],
  target: {
    appliesTo: 'ELEMENT',
    styleBlockIds: [],
    id: `62d9d85eabf70f5be939b4af|anotherTarget`,
  },
  targets: [
    {
      appliesTo: 'ELEMENT',
      styleBlockIds: [],
      id: `5ee24b20e1111458e8ead23a|${targetId}`,
    },
    {
      appliesTo: 'ELEMENT',
      styleBlockIds: [],
      id: `5ee24b20e1111458e8ead23a|another-target`,
    },
  ],
  config: {
    loop: false,
    playInReverse: false,
    scrollOffsetValue: null,
    scrollOffsetUnit: null,
    delay: 0,
    direction: 'LEFT',
    effectIn: true,
  },
  createdOn: 1663883254354,
});

export const generateTestIx2CPGActionList = (
  targetId: string,
  actionId?: string
): ActionListType => ({
  id: actionId || 'a',
  title: 'New Mouse Animation',
  continuousParameterGroups: [
    {
      id: 'a-p',
      type: 'MOUSE_X',
      parameterLabel: 'Mouse X',
      continuousActionGroups: [
        {
          keyframe: 0,
          actionItems: [
            {
              id: 'a-n',
              actionTypeId: 'TRANSFORM_ROTATE',
              config: {
                delay: 0,
                easing: '',
                duration: 500,
                target: {
                  nodeId: `62d9d85eabf70f5be939b4af|${targetId}`,
                  appliesTo: 'ELEMENT',
                  boundaryMode: false,
                  styleBlockIds: undefined,
                  useEventTarget: undefined,
                },
                xValue: undefined,
                yValue: undefined,
                zValue: undefined,
                xUnit: 'DEG',
                yUnit: 'DEG',
                zUnit: 'DEG',
              },
              instant: false,
            },
          ],
        },
        {
          keyframe: 100,
          actionItems: [
            {
              id: 'a-n-2',
              actionTypeId: 'TRANSFORM_ROTATE',
              config: {
                delay: 0,
                easing: '',
                duration: 500,
                target: {
                  nodeId: `62d9d85eabf70f5be939b4af|${targetId}`,
                  appliesTo: 'ELEMENT',
                  boundaryMode: false,
                  styleBlockIds: undefined,
                  useEventTarget: undefined,
                },
                xValue: undefined,
                yValue: undefined,
                zValue: undefined,
                xUnit: 'DEG',
                yUnit: 'DEG',
                zUnit: 'DEG',
              },
              instant: false,
            },
          ],
        },
      ],
    },
    {
      id: 'a-p-2',
      type: 'MOUSE_Y',
      parameterLabel: 'Mouse Y',
      continuousActionGroups: [
        {
          keyframe: 0,
          actionItems: [
            {
              id: 'a-n-3',
              actionTypeId: 'TRANSFORM_SCALE',
              config: {
                delay: 0,
                easing: '',
                duration: 500,
                target: {
                  nodeId: `62d9d85eabf70f5be939b4af|${targetId}`,
                  appliesTo: 'ELEMENT',
                  boundaryMode: false,
                  styleBlockIds: undefined,
                  useEventTarget: undefined,
                },
                locked: true,
                xValue: undefined,
                yValue: undefined,
                zValue: undefined,
              },
              instant: false,
            },
          ],
        },
        {
          keyframe: 100,
          actionItems: [
            {
              id: 'a-n-4',
              actionTypeId: 'TRANSFORM_SCALE',
              config: {
                delay: 0,
                easing: '',
                duration: 500,
                target: {
                  nodeId: `62d9d85eabf70f5be939b4af|${targetId}`,
                  appliesTo: 'ELEMENT',
                  boundaryMode: false,
                  styleBlockIds: undefined,
                  useEventTarget: undefined,
                },
                locked: true,
                xValue: undefined,
                yValue: undefined,
                zValue: undefined,
              },
              instant: false,
            },
          ],
        },
      ],
    },
  ],
  createdOn: 1663887864761,
});

export const generateTestIx2AIGActionList = (
  targetId: string,
  actionId?: string
): ActionListType => ({
  id: actionId || 'a-3',
  title: 'New Timed Animation',
  actionItemGroups: [
    {
      actionItems: [
        {
          id: 'a-3-n',
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: '',
            duration: 500,
            target: {
              nodeId: `62d9d85eabf70f5be939b4a7|${targetId}`,
              appliesTo: 'ELEMENT',
              styleBlockIds: ['5e819dec-3019-cef0-c313-0a17cd6da550'],
              boundaryMode: false,
              useEventTarget: undefined,
            },
            locked: true,
            xValue: undefined,
            yValue: undefined,
            zValue: undefined,
          },
          instant: false,
        },
      ],
    },
    {
      actionItems: [
        {
          id: 'a-3-n-2',
          actionTypeId: 'STYLE_BACKGROUND_COLOR',
          config: {
            delay: 0,
            easing: '',
            duration: 500,
            target: {
              nodeId: `62d9d85eabf70f5be939b4a7|${targetId}`,
              appliesTo: 'ELEMENT',
              styleBlockIds: ['5e819dec-3019-cef0-c313-0a17cd6da550'],
              boundaryMode: false,
              useEventTarget: undefined,
            },
            globalSwatchId: undefined,
            rValue: undefined,
            bValue: undefined,
            gValue: undefined,
            aValue: undefined,
          },
          instant: false,
        },
      ],
    },
  ],
  createdOn: 1664231545686,
  useFirstGroupAsInitialState: false,
});

export const generateStyleBlockMap = (
  styleBlocks: Array<RawStyleBlockServerType>
) =>
  styleBlocks.reduce<Record<string, RawStyleBlockServerType>>((memo, block) => {
    memo[block._id] = block;
    return memo;
  }, {});

export const generateLibraryResourceForTest = (
  name: string,
  plugin: Plugins.PluginDeclarations,
  source?: LIBRARY_SOURCE
): LibraryVersionedResource => ({
  id: 'library-id',
  profileId: 'profile-id',
  type: 'LIBRARY',
  displayName: name,
  version: '1.0.0',
  installer: 'Wolf Dew',
  plugin: {
    type: 'CONTENT',
    value: plugin,
  },
  exports: getLibraryExportsFromPlugin(plugin),
  source: source || LIBRARY_SOURCE.WORKSPACE,
  profileStatus: LIBRARY_PROFILE_STATUS.SHARED,
});

export const nestedComponentExports: ComponentExport[] = [
  {
    type: 'Component',
    subtype: LIBRARY_EXPORT_SUBTYPES.COMPONENT,
    metadata: {
      targetComponentId: '0376276b-09d2-7383-5539-8191edcda000',
      displayName: 'Wrapper',
    },
  },
  {
    type: 'Component',
    subtype: LIBRARY_EXPORT_SUBTYPES.COMPONENT,
    metadata: {
      targetComponentId: '0376276b-09d2-7383-5539-8191edddd111',
      displayName: 'Wrapper 2',
    },
  },
  {
    type: 'Component',
    subtype: LIBRARY_EXPORT_SUBTYPES.COMPONENT,
    metadata: {
      targetComponentId: '9b6dcf5b-4a96-4d65-23e0-fda0a288dcf2',
      displayName: 'Submit Button',
    },
  },
  {
    type: 'Component',
    subtype: LIBRARY_EXPORT_SUBTYPES.COMPONENT,
    metadata: {
      targetComponentId: '0738276b-09d2-7383-5539-8191edcdcaa0',
      displayName: 'My Image',
    },
  },
  {
    type: 'Component',
    subtype: LIBRARY_EXPORT_SUBTYPES.COMPONENT,
    metadata: {
      targetComponentId: '0738276b-09d2-7383-5539-8191edcdcaa1',
      displayName: 'Card',
    },
  },
  {
    type: 'Component',
    subtype: LIBRARY_EXPORT_SUBTYPES.COMPONENT,
    metadata: {
      targetComponentId: '8003171d-8277-7b67-1ac2-6abea4c13632',
      displayName: 'my component',
    },
  },
  {
    type: 'Component',
    subtype: LIBRARY_EXPORT_SUBTYPES.COMPONENT,
    metadata: {
      targetComponentId: 'b8de832f-94e3-f76f-e856-2010c86ec743',
      displayName: 'My Link with props',
    },
  },
];

export const circularComponentExports: ComponentExport[] = [
  {
    metadata: {
      targetComponentId: 'c3e04ce2-00a3-c6fe-6971-a66c27e927d6',
      displayName: 'Component with circular reference',
    },
    type: 'Component',
    subtype: LIBRARY_EXPORT_SUBTYPES.COMPONENT,
  },
];
